export default "__VITE_ASSET__DKSbZFa5__"